export { default } from './HideElement';
